import { useReportTypes } from "../hooks/useReportTypes.js";
import "react";
import { Skeleton } from "@therms/atalaya";
import { Fragment as Fragment$1, jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/Reports/shared/ReportTypeNames.tsx
var ReportTypeNames = ({ listAll = true, reportTypeIds }) => {
	const { data, loading } = useReportTypes({ reportTypeIds }, { cacheStrategy: "cache-only" });
	if (!data?.reportTypes && loading) return /* @__PURE__ */ jsx(Skeleton.Text, { chars: 25 });
	if (!data?.reportTypes || !reportTypeIds?.length) return null;
	if (!listAll && data.total > 1) return /* @__PURE__ */ jsxs("div", {
		className: "flex min-w-0 flex-nowrap",
		children: [/* @__PURE__ */ jsx("div", {
			className: "truncate",
			children: data.reportTypes[0].name
		}), /* @__PURE__ */ jsxs("span", {
			className: "text-info pl-xxs min-w-fit flex-1",
			children: ["+", data.total - 1]
		})]
	});
	return /* @__PURE__ */ jsx(Fragment$1, { children: data.reportTypes.map(({ name }) => name).join(", ") });
};
//#endregion
export { ReportTypeNames };

//# sourceMappingURL=ReportTypeNames.js.map